<template>
    <div class="vrm-fieldset__item sg-custom-check-and-radio sg-custom-check" @click="onClick">
        <label
            class="vrm-fieldset__item__label sg-textfield-label"
            :class="{ 'sg-required': required }"
        >
            <input :id="fieldId" v-model="value" type="checkbox" />

            <div class="sg-alternative-display">
                <div class="sg-icon-check" />
            </div>
        </label>
    </div>
</template>
<style scoped lang="scss"></style>
<script>
import { Vue, Component, Prop, Model } from 'vue-property-decorator';
import VrmToggleCheckmark from '@/vue/components/shared/toggles/VrmToggleCheckmark';
import VrmToggle from '@/vue/components/shared/toggles/VrmToggle';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';
@Component({
    components: { VrmToggle, VrmToggleCheckmark },
    inheritAttrs: false,
})
@AngularLocaleBundle('form')
export default class VrmCheckbox extends Vue {
    @Prop({ type: Boolean, default: false })
    required;

    @Model('input')
    model;

    @Prop({ type: String, default: null })
    inputId;

    get value() {
        return this.model;
    }

    set value(newValue) {
        this.$emit('input', newValue);
    }

    get fieldId() {
        return this.inputId || 'someid';
    }

    onClick() {
        this.value = !this.value;
    }
}
</script>
